export const FEATURE_KEYS = {
  CORE_MY_VESSELS: "core.myVessels",
  CORE_SEARCH_VESSELS: "core.searchVessels",
  CORE_CERTS: "core.certs",
  VESSEL_CARD_ACCESS: "vesselCard.access",
  SISTERSHIP_ACCESS: "sistership.access",
  VOYAGE_PNL: "voyage.pnl",
  JARVIS_UWHC_AI_AGENT: "jarvis.uwhcAiAgent",
  JARVIS_OPS_KNOWLEDGE_OUTPUT_AI_AGENT: "jarvis.opsKnowledgeOutputAiAgent",
  REVIEW_PNL: "review.pnl",
  TQ_FORMS: "tq.forms",
  TQ_ADMIN: "tq.admin",
  HOLD_CLEANING_ACCESS: "holdCleaning.access",
  HOLD_CLEANING_ADMIN: "holdCleaning.admin",
  ADMIN_DEBUG_MONITORING: "admin.debugMonitoring",
  ADMIN_ACCESS_CONTROL_ROLE_FEATURES: "admin.accessControl.roleFeatures",
  ADMIN_ANALYTICS_FLEET_ANALYSIS: "admin.analytics.fleetAnalysis",
  ADMIN_ANALYTICS_CERTS: "admin.analytics.certs",
  ADMIN_REF_PARAMETERS_CERTS: "admin.refParameters.certs",
  ADMIN_REF_PARAMETERS_UWHC_VENDORS: "admin.refParameters.uwhcVendors",
  ADMIN_REF_PARAMETERS_PAINT_SCHEMES: "admin.refParameters.paintSchemes",
  ADMIN_REF_PARAMETERS_SENIOR_VO: "admin.refParameters.seniorVo",
  ADMIN_REF_PARAMETERS_TEAM_ROLES: "admin.refParameters.teamRoles",
  ADMIN_CREW_REPORT: "admin.crewReport",
  CREW_REPORT_OPERATIONAL_ACTIONS: "crewReport.operationalActions",
  CREW_REPORT_IMPORT_ACTIONS: "crewReport.importActions",
  CREW_REPORT_BULK_REQUESTS: "crewReport.bulkRequests",
  OKTA_EXTERNAL_ADMIN: "okta.externalAdmin",
} as const;

export const FEATURE_KEY_VALUES = Object.values(FEATURE_KEYS);
export type FeatureKey = (typeof FEATURE_KEY_VALUES)[number];

export const EMPTY_EFFECTIVE_ACCESS_CONTROL: EffectiveAccessControl = {
  grantedFeatures: [],
  matchedRoles: [],
  permissions: {},
  source: "fallback",
};

export type PermissionMap = Record<string, boolean>;
export type AccessControlSource = "snowflake" | "fallback";

export interface RoleFeatureDefinition {
  featureKey: FeatureKey;
  featureGroup: string;
  featureLabel: string;
  description: string;
}

export interface RoleFeatureMatrixRole {
  roleKey: string;
  displayTeam: string;
  comment: string;
  isActive: boolean;
  permissions: PermissionMap;
}

export interface RoleFeatureMatrix {
  roles: RoleFeatureMatrixRole[];
  features: RoleFeatureDefinition[];
  source: AccessControlSource;
}

export interface EffectiveAccessControl {
  grantedFeatures: string[];
  matchedRoles: string[];
  permissions: PermissionMap;
  source: AccessControlSource;
}

export interface CreateRoleFeatureRoleInput {
  roleKey: string;
  displayTeam: string;
  comment?: string;
  permissions?: PermissionMap;
}

export interface UpdateRoleFeatureRoleInput {
  displayTeam?: string;
  comment?: string;
  permissions?: PermissionMap;
}

export const ADMIN_FEATURE_KEYS = [
  FEATURE_KEYS.HOLD_CLEANING_ADMIN,
  FEATURE_KEYS.ADMIN_DEBUG_MONITORING,
  FEATURE_KEYS.ADMIN_ACCESS_CONTROL_ROLE_FEATURES,
  FEATURE_KEYS.ADMIN_ANALYTICS_CERTS,
  FEATURE_KEYS.ADMIN_REF_PARAMETERS_CERTS,
  FEATURE_KEYS.ADMIN_REF_PARAMETERS_UWHC_VENDORS,
  FEATURE_KEYS.ADMIN_REF_PARAMETERS_PAINT_SCHEMES,
  FEATURE_KEYS.ADMIN_REF_PARAMETERS_SENIOR_VO,
  FEATURE_KEYS.ADMIN_CREW_REPORT,
] as const;
